import type { IconData } from "@loot-os/icons/types";
import type { ReactNode } from "react";
import { Icon } from "../../core/Icon.js";
import { cn } from "../../foundations/cn.js";

export interface ChatSystemMessageProps {
  children: ReactNode;
  icon?: IconData;
  /** `accent` for news the room should notice: a break starting, a drop landing. */
  tone?: "neutral" | "accent";
  className?: string;
}

/** A line from the store rather than a person: a break starting, slow mode on, a drop landing. */
export function ChatSystemMessage({
  children,
  icon,
  tone = "neutral",
  className,
}: ChatSystemMessageProps) {
  return (
    <p
      className={cn(
        "flex items-center gap-2 px-2 py-1.5 font-mono text-mono-meta uppercase",
        tone === "accent" ? "text-accent-text" : "text-text-tertiary",
        className,
      )}
    >
      {icon && <Icon icon={icon} size={12} />}
      {children}
    </p>
  );
}
